/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

// Get role constants
export const ADMIN_EMAIL_APPROVAL_REQUEST_GET = 'ADMIN_EMAIL_APPROVAL_REQUEST_GET';
export const ADMIN_EMAIL_APPROVAL_RESPONSE_GET_SUCCESS = 'ADMIN_EMAIL_APPROVAL_RESPONSE_GET_SUCCESS';
export const ADMIN_EMAIL_APPROVAL_RESPONSE_GET_FAIL = 'ADMIN_EMAIL_APPROVAL_RESPONSE_GET_FAIL'

// Get admin email approval permissions constants

export const ADMIN_EMAIL_APPROVAL_REQUEST_POST = 'ADMIN_EMAIL_APPROVAL_REQUEST_POST';
export const ADMIN_EMAIL_APPROVAL_RESPONSE_POST_FAIL = 'ADMIN_EMAIL_APPROVAL_RESPONSE_POST_FAIL';
export const  ADD_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS = 'ADD_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS';
export const  ADD_ADMIN_EMAIL_APPROVAL_RESET_SUCCESS_MSG_OR_ERROR = 'ADD_ADMIN_EMAIL_APPROVAL_RESET_SUCCESS_MSG_OR_ERROR';
export const THIS_ADMIN_EMAIL_ALREADY_EXISTS = 'THIS_ADMIN_EMAIL_ALREADY_EXISTS';

/**
 * Action types for patch admin email data.
 *
 * These constants represent different stages of the admin email data editing process
*/
export const ADMIN_EMAIL_APPROVAL_REQUEST_PATCH = 'ADMIN_EMAIL_APPROVAL_REQUEST_PATCH';
export const ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_FAIL = 'ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_FAIL';
export const ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_SUCCESS = 'ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_SUCCESS';
export const ADMIN_DETAIL_SUCCESSFULLY_UPDATED = 'ADMIN_DETAIL_SUCCESSFULLY_UPDATED';
export const OLD_PASSWORD_NOT_MATCHED = 'OLD_PASSWORD_NOT_MATCHED';




/**
 * Action types for put admin email data.
 *
 * These constants represent different stages of the admin email data deleting process
*/

export const ADMIN_EMAIL_APPROVAL_REQUEST_PUT = 'ADMIN_EMAIL_APPROVAL_REQUEST_PUT';
export const ADMIN_EMAIL_APPROVAL_RESPONSE_PUT_FAIL = 'ADMIN_EMAIL_APPROVAL_RESPONSE_PUT_FAIL';
export const DELETE_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS = 'DELETE_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS';
export const RESET_ADMIN_EMAIL_APPROVAL_DELETE = 'RESET_ADMIN_EMAIL_APPROVAL_DELETE';
export const ADMIN_SUCCESSFULLY_DELETED= 'ADMIN_SUCCESSFULLY_DELETED';
export const ADMIN_DOES_NOT_EXISTS = 'ADMIN_DOES_NOT_EXISTS';
export const FAILED_TO_DELETE_ADMIN = 'FAILED_TO_DELETE_ADMIN';

export const ADMIN_DETAIL_SUCCESSFULLY_ADDED = 'ADMIN_DETAIL_SUCCESSFULLY_ADDED';



export const ADMIN_EMAIL_APPROVAL_EDIT_MODAL = 'ADMIN_EMAIL_APPROVAL_EDIT_MODAL';
export const ADMIN_EMAIL_APPROVAL_ADD_MODAL = 'ADMIN_EMAIL_APPROVAL_ADD_MODAL';
export const ADMIN_EMAIL_APPROVAL_SELECTED = 'ADMIN_EMAIL_APPROVAL_SELECTED';
export const DELETE_ACTION_TRIGGERED = 'DELETE_ACTION_TRIGGERED';
export const SET_EMAIL_VALUE = 'SET_EMAIL_VALUE';
export const SET_IS_SUPER_ADMIN_VALUE = 'SET_IS_SUPER_ADMIN_VALUE';
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';

